import { State } from 'src/types'
import { crownBackStyleDrawer } from './crownBackStyle'
import { beltBackStyleDrawer } from './beltBackStyleDrawer'
import { firstBackStyleDrawer } from './firstBackStyleDrawer'

export const backStyleOfGloveBackDrawer = async (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): Promise<void> => {
  await beltBackStyleDrawer(ctx, state, needCatchFaceWrap) // 通常ベルトモデル
  await crownBackStyleDrawer(ctx, state, needCatchFaceWrap) // 王冠モデル
  await firstBackStyleDrawer(ctx, state) // ファーストバックモデル
}
